import { faArrowRight, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import giftImg from '../../../images/webp/gift.webp';
import blueGif from '../../../images/gif/blue.gif';
import logoSvg from '../../../images/icon/logo.svg';
import footerSvg from '../../../images/icon/footer-logo.svg';
import { faFacebook, faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
    return (
        <div className="mt-5">
            <div style={{ backgroundImage: `url(${blueGif})`, backgroundSize: 'cover', backgroundPosition: 'center', borderRadius: 20 }} className="row align-items-center text-center text-light">
                <div data-aos="fade-up" data-aos-duration="2000" className="col-md-4">
                    <img className="w-100" src={giftImg} alt="" />
                </div>
                <div data-aos="fade-up" data-aos-duration="2500" className="col-md-4">
                    <h4 style={{ color: "#ff3465" }}>Ready to have some fun?</h4>
                    <h2 className="fw-bolder">Get in touch with us!</h2>
                </div>
                <div data-aos="fade-up" data-aos-duration="3000" className="col-md-4">
                    <h3>+880 1870 289 584</h3>
                    <h5>Monday - Friday 09:00 AM - 06:00 PM</h5>
                    <h5>Saturday 07:00 AM - 08:00 PM</h5>
                    <Link to="/contact" className="btn rounded-pill me-2 btn-global-style-solid">
                        Contact <FontAwesomeIcon icon={faArrowRight} />
                    </Link>
                </div>
            </div>
            <div className="row align-items-center">
                <div data-aos="fade-down" data-aos-duration="1500" className="col-md-4">
                    <img className="w-100" src={logoSvg} alt="" />
                    <p>Vitae ipsum eu neque massa justo nisi morbi. Placerat mauris tellus enim pharetra. Ac ac.</p>
                    <h3>
                        <a href="https://mehedy-portfolio.web.app/" target="_blank" rel="noopener noreferrer" className="m-2">
                            <FontAwesomeIcon icon={faUser} />
                        </a>
                        <a href="https://www.linkedin.com/notifications/" target="_blank" rel="noopener noreferrer" className="m-2">
                            <FontAwesomeIcon icon={faLinkedin} />
                        </a>
                        <a href="https://github.com/mdmehedyhassan" target="_blank" rel="noopener noreferrer" className="m-2">
                            <FontAwesomeIcon icon={faGithub} />
                        </a>
                        <a href="https://www.facebook.com/mehedysr/" target="_blank" rel="noopener noreferrer" className="m-2">
                            <FontAwesomeIcon icon={faFacebook} />
                        </a>
                    </h3>
                </div>
                <div data-aos="fade-down" data-aos-duration="2500" className="col-md-6">
                    <div className="row">
                        <div className="col-5">
                            <h3 className="fw-bolder ">Navigation</h3>

                            <Link to="/home" className="navbar-global-style">Home</Link> <br />
                            <Link to="/events" className="navbar-global-style">Events</Link> <br />
                            <Link to="/contact" className="navbar-global-style">Contact us</Link> <br />
                            <Link to="/" className="navbar-global-style">Cookies</Link> <br />
                        </div>
                        <div className="col-7">
                            <h3 className="fw-bolder">Offer</h3>
                            <Link to="/offer" className="navbar-global-style">Bachelorette parties</Link> <br />
                            <Link to="/offer" className="navbar-global-style">New Year's Eve parties</Link> <br />
                            <Link to="/offer" className="navbar-global-style">Birthday parties Corporate</Link> <br />
                            <Link to="/offer" className="navbar-global-style">Corporate events</Link> <br />
                        </div>
                    </div>
                </div>
                <div data-aos="fade-down" data-aos-duration="3000" className="col-md-2">
                    <img className="w-100" src={footerSvg} alt="" />
                </div>
            </div>
            <footer style={{ borderTop: '1px solid gray', marginTop: 30, padding: 15, textAlign: 'center'}}>
                <p>
                    <small>
                    © 2022 Md Mehedy Hassan <a className="btn btn-outline-info" href="https://github.com/mdmehedyhassan/event" target="_blank" rel="noopener noreferrer">Github Code link</a>
                    </small>
                </p>
            </footer>
        </div>
    );
};

export default Footer;